import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const FilterWrapper = styled.div`
  width: 100%;
  min-width: ${unitizedPx(28)};
`;
